import React, { useEffect, useRef, useState } from "react";
import SellItMark from "./SellItMark";
import * as S from "./styles";
import type { VarianteLoader } from "./styles";

export type { VarianteLoader };

// Variante padrão do loader no app. Trocar aqui muda o visual em todas as
// telas que usam o overlay sem passar `variante`.
export const VARIANTE_PADRAO: VarianteLoader = "sellit";

const DURACAO_FADE_OUT = 180;

interface Props {
  open: boolean;
  titulo?: string;
  descricao?: string;
  variante?: VarianteLoader;
}

export default function LoadingOverlay({
  open,
  titulo = "Por favor, aguarde!",
  descricao = "Estamos carregando as suas informações.",
  variante = VARIANTE_PADRAO,
}: Readonly<Props>): JSX.Element | null {
  // O overlay precisa continuar montado durante o fade out, então `visivel`
  // acompanha `open` com atraso na saída.
  const [visivel, setVisivel] = useState(open);
  const [saindo, setSaindo] = useState(false);
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => {
    clearTimeout(timeoutRef.current);

    if (open) {
      setSaindo(false);
      setVisivel(true);
      return undefined;
    }

    if (!visivel) return undefined;

    setSaindo(true);
    timeoutRef.current = setTimeout(() => {
      setVisivel(false);
      setSaindo(false);
    }, DURACAO_FADE_OUT);

    return () => clearTimeout(timeoutRef.current);
  }, [open]);

  useEffect(() => () => clearTimeout(timeoutRef.current), []);

  if (!visivel) return null;

  return (
    <S.Backdrop saindo={saindo} role="status" aria-live="polite">
      <S.Loader variante={variante}>
        <S.Spinner variante={variante} />
        {variante === "semLogo" ? null : (
          <S.LogoWrapper>
            <SellItMark />
          </S.LogoWrapper>
        )}
      </S.Loader>
      <S.Title>{titulo}</S.Title>
      <S.Description>{descricao}</S.Description>
    </S.Backdrop>
  );
}
